import { createSlice } from '@reduxjs/toolkit'
import Config from '../Config'

const slice = createSlice({
  name: 'menu',
  initialState: { expanded: Config.ui.defaultExpandedMainMenu },
  reducers: {
    setExpanded: (state, { payload }) => {
      state.expanded = payload
    },
    toggleExpanded: (state) => {
      state.expanded = !state.expanded
    },
  },
})

export const { setExpanded, toggleExpanded } = slice.actions

export default slice.reducer

export const selectMenuExpanded = (state) => state.ui.menu.expanded
